import UserModel from '../models/UserModel';
import IService from './IService';
import Axios from 'axios';

export default class UserService implements IService<UserModel> {

    constructor() {
    }

    async list(filter: any) {
        const data = [];
        var res = await Axios.post('/api/users/list', filter)
        .then(res => {
            if (res.data.success) {
                let obj = res.data.data.map((itm: any) => {
                    let ret = new UserModel();
                    ret.idNUsuario = itm.idNUsuario;
                    ret.fkNTipoUsuario = itm.fkNTipoUsuario;
                    ret.fldBActivo = itm.fldBActivo;
                    ret.fldTEmail = itm.fldTEmail;
                    ret.fldTLogin = itm.fldTLogin;
                    ret.fldTNombre = itm.fldTNombre;

                    return ret;
                });
                let result = {
                    success: true,
                    data: obj
                }
                return result;
            }
            return null;
        }).catch(error => {
            let result = {
                success: false,
                Message: error.response.data.responseErrorMessage
            }
            return result;
        });
        return res;
    }

    async listTypes() {
        var res = await Axios.get('/api/usertypes/list');
        if (res.data.success) {
            return res.data.data;
        }
        return [];
    }

    async insert(data: UserModel) {
        var res = await Axios.post('/api/users/insert', data);
        return res.data;
    }

    async update(data: UserModel) {
        var res = await Axios.put('/api/users/update', data);
        return res.data;
    }

    async delete(data: UserModel) {
        var res = await Axios.delete('/api/users/delete?id=' + data.idNUsuario);
        return res.data;
    }    

    async get(id:any) {
        var res = await Axios.get('/api/users/get?id=' + id);
        return res.data;
    }

    async export(filter: any) {
        var res = await Axios.post('/api/users/export', filter, {
            responseType: 'blob'
        });
        return res.data;
    }

}